export enum PickUpType {
  MYSELF = 'myself',
  BRING_ME = 'bring-me',
}
